export default __webpack_public_path__ + "static/media/jackale.727cda16.png";